<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Moods
        <small>List of moods</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Moods</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right" @click.prevent="add">
            Add New Mood
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Slug</th>
                <th class="text-center">Image</th>
                <th>Action(s)</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="mood in moods">
                <td>{{ mood.name }}</td>
                <td>{{ mood.slug }}</td>
                <td>
                  <img
                    v-if="mood.image_url && mood.image_url != ''"
                    :src="parseImage(mood.image_url, '_thumb')"
                    style="width: 64px;" />
                </td>
                <td>
                  <a class="btn btn-primary btn-xs" @click.prevent="edit(mood.id)">Edit</a>
                  <a class="btn btn-danger btn-xs" @click.prevent="remove(mood)">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'MoodIndex',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      moods: [],
      pagination: {},
    };
  },

  methods: {
    fetch(page) {
      const pageQuery = this.$route.query.page;

      const params = {
        page: page || pageQuery,
      };

      this.axios.get('/moods', { params })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            return;
          }

          this.moods = data;
          this.pagination = meta.pagination;
        });

      if (page) {
        window.history.pushState(`Categories page: ${page}`, null, `/categories?page=${page}`);
      }
    },

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({
        name: 'mood-create',
      });
    },

    edit(id) {
      this.$router.push({
        name: 'mood-edit',
        params: {
          id,
        },
      });
    },

    delete(mood) {
      this.axios.delete(`/moods/${mood.id}`)
        .then(() => {
          this.fetch();

          this.$swal({
            title: 'Deleted',
            text: `${mood.name} has been deleted.`,
            type: 'success',
            timer: 3000,
          });
        });
    },

    remove(mood) {
      this.$swal({
        title: 'Deleting Mood',
        text: `Are you sure you want to delete ${mood.name}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.value) {
          this.delete(mood);
        } else {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }
      });
    },
  },

  created() {
    this.fetch();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/moods/Index.vue